import './index.css';

export function FormHeader(): React.ReactNode {
    return (
        <div className='header'>
            <img alt='logo' src='/images/ico_sportradar_white.svg' />
        </div>
    );
}
